package uk.co.nickthecoder.glok.backend.webgl

import org.khronos.webgl.WebGLRenderingContext.Companion.TEXTURE_2D
import org.khronos.webgl.WebGLRenderingContext.Companion.TRIANGLE_STRIP
import uk.co.nickthecoder.glok.backend.Texture
import uk.co.nickthecoder.glok.util.Matrix
import uk.co.nickthecoder.glok.util.log

internal class TextureProgram private constructor() : UVProgram(VERTEX, FRAGMENT) {

    private fun begin(viewMatrix: Matrix, texture: Texture) {
        begin(viewMatrix)
        texture.bind()
    }

    fun draw(
        left: Float, bottom: Float, right: Float, top: Float,
        tLeft: Float, tBottom: Float, tRight: Float, tTop: Float
    ) {
        drawTriangles(
            arrayOf<Float>(
                left, bottom, tLeft, tBottom,
                right, bottom, tRight, tBottom,
                left, top, tLeft, tTop,
                right, top, tRight, tTop
            ), TRIANGLE_STRIP
        )
    }

    override fun end() {
        super.end()
        WebGLBackend.gl.bindTexture(TEXTURE_2D, null)
    }

    companion object {
        private val instance = TextureProgram()

        fun use(viewMatrix: Matrix, texture: Texture, block: TextureProgram.() -> Unit) {
            instance.begin(viewMatrix, texture)
            instance.block()
            instance.end()
        }
    }
}

private const val VERTEX = """
attribute vec2 position;
attribute vec2 uv;

uniform mat3 viewMatrix;

varying vec2 textureCoord;

void main() {
    textureCoord = uv;

    gl_Position = vec4( viewMatrix * vec3(position, 1.0), 1.0);
}

"""

private const val FRAGMENT = """  
 precision highp float;

varying vec2 textureCoord;

uniform sampler2D texImage;

void main() {
    gl_FragColor = texture2D(texImage, textureCoord);
}

"""
